import { useFlags } from 'launchdarkly-react-client-sdk';
import NsContent from 'components/common/ns-content/NsContent';
import { useSelector, shallowEqual } from 'react-redux';

import { NsLandmark } from 'components/common/ns-landmark/NsLandmark';
import { NsList } from 'components/common/ns-list/NsList';
import { QuoteSection } from 'components/common/quote-section/QuoteSection';
import { Feature } from 'components/common/feature/Feature';
import { ToggleJourney } from 'components/app/routes/ToggleJourney';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { selectors as meterTypeSelectors } from 'state/meter-type/meter-type-slice';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';

import BannerImgLG from 'assets/images/banner-image-05-lg.jpg';

const { selectIsLoading: selectIsLoadingMeterType } = meterTypeSelectors;

export const testId = 'VoiceSalesHomeMoveTestId';

export const VoiceSalesHomeMove = () => {
  const { allowJourneyVoicesalesHomemove } = useFlags();
  const isLoadingMeterType = useSelector(
    selectIsLoadingMeterType,
    shallowEqual
  );

  if (isLoadingMeterType) {
    return <NsStopgap />;
  }

  return (
    <Feature
      feature={allowJourneyVoicesalesHomemove}
      inactiveComponent={<ToggleJourney off />}
    >
      <div data-testid={testId}>
        <NsLandmark
          image={BannerImgLG}
          heading="MVH Acq  - Agent Journey"
          ratio="16x9"
        >
          <p>
            This journey is a temporary solution to help acquire a BG Property
            on the NEP Platform when an NEP customer would like to lift and
            shift their previous tariff to their new property.
            <br /> The move in on the Classic platform needs to be completed
            first before this journey is used to acquire the property on NEP.
            <br />
            In some circumstances exceptions can be identified, meaning the
            customer cannot be supported in NEP. In this case you would need to
            inform the customer that it isn&apos;t possible to lift and shift
            their tariff.
          </p>
        </NsLandmark>
        <NsPanel>
          <NsContent>
            <h5>Customer Eligibility</h5>
            <NsList>
              {[
                'Must be a credit customer paying by monthly fixed Direct Debit or paying on receipt of the bill',
                `For customers who want an EV tariff please check that they have a working SMART meter that is sending reads to their current provider. If they do not have a SMART meter or it isn't sending reads please follow the SAP journey.`
              ]}
            </NsList>
            <h5>
              To make sure your customer can benefit from our tariffs check they
              are happy with the following:
            </h5>
            <NsList>
              {[
                'If the customer has a Smart meter please mention to the customer that “their meter may no longer work as smart meter and customer might need to submit their readings for some time."',
                `Confirm if the customer is happy to manage their account online and receive email correspondence`
              ]}
            </NsList>
          </NsContent>

          <QuoteSection title="Get a quote" />
        </NsPanel>
      </div>
    </Feature>
  );
};

export default VoiceSalesHomeMove;
